import { render, staticRenderFns } from "./TheResultNotEligible.vue?vue&type=template&id=6ced0a89&"
import script from "./TheResultNotEligible.vue?vue&type=script&lang=js&"
export * from "./TheResultNotEligible.vue?vue&type=script&lang=js&"
import style0 from "./TheResultNotEligible.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports